"use client";
import React from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import {
  Calendar,
  LayoutGrid,
  Settings,
  Users,
  BarChart,
  Swords,
  BrainCircuit,
  MessageSquare, // ✅ NEU
} from "lucide-react";
import { SidebarMenu, SidebarMenuItem, SidebarMenuButton } from "../ui/sidebar";
import { useTranslations } from "next-intl";

export default function SidebarNav() {
  const pathname = usePathname();
  const t = useTranslations();

  // Define links inside the component so they are re-evaluated on language change
  const links = [
    { href: "/dashboard", label: t('nav.dashboard'), icon: LayoutGrid },
    { href: "/trades", label: t('nav.trades'), icon: Swords },
    { href: "/calendar", label: t('nav.calendar'), icon: Calendar },
    { href: "/reports", label: t('nav.reports'), icon: BarChart },
    { href: "/profiles", label: t('nav.profiles'), icon: Users },
    { href: "/strategy", label: t('nav.strategy'), icon: BrainCircuit },
    { href: "/feedback", label: t('nav.feedback'), icon: MessageSquare }, // ✅ NEU
    { href: "/settings", label: t('nav.settings'), icon: Settings },
  ];

  return (
    <SidebarMenu>
      {links.map((link) => (
        <SidebarMenuItem key={link.href}>
          <Link href={link.href}>
            <SidebarMenuButton
              isActive={pathname?.startsWith(link.href) ?? false}
              tooltip={link.label}
              className="h-12 px-4 gap-4"
            >
              <link.icon className="h-6 w-6" />
              <span className="font-semibold leading-none">
                {link.label}
              </span>
            </SidebarMenuButton>
          </Link>
        </SidebarMenuItem>
      ))}
    </SidebarMenu>
  );
}
